<script setup lang="ts">
import Skeleton from '@/shared/ui/Skeleton/index';

const isMobile: boolean = useIsMobile();

const count = isMobile ? 9 : 12;
</script>

<template>
  <div :class="['time-slots-skeleton', { _mobile: isMobile }]">
    <Skeleton v-for="n in count" :key="`slot-skeleton-${n}`" width="100%" height="40px" />
  </div>
</template>

<style lang="less" scoped>
.time-slots-skeleton {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-column-gap: 3px;
  grid-row-gap: 9px;
  width: 100%;

  &._mobile {
    grid-template-columns: repeat(3, 1fr);
    grid-column-gap: @size-x2;
  }
}
</style>
